import React from 'react';

const questions = {
  en: [
    "What parent hasn't repeatedly invested in school supplies that end up lost, never making it back home?",
    "What school hasn't accumulated piles of lost items without an effective way to return them?"
  ],
  es: [
    "¿Qué padre no ha invertido, una y otra vez, en artículos escolares que terminan extraviados sin posibilidad de volver a casa?",
    "¿Qué escuela no ha acumulado montones de objetos perdidos sin un canal efectivo para devolverlos?"
  ],
  pt: [
    "Que pai não investiu repetidamente em materiais escolares que acabam se perdendo sem chance de voltar para casa?",
    "Que escola não acumulou pilhas de objetos perdidos sem um canal eficaz para devolvê-los?"
  ]
};

const introBlock = {
  en: {
    title: "A daily problem. A human solution.",
    text: "Whether at home or at school, the loss of everyday items causes frustration and disconnection. That’s why YourLostAndFound was created: to bring order, connection, and peace of mind—one tag at a time."
  },
  es: {
    title: "Un problema cotidiano. Una solución humana.",
    text: "Ya sea en casa o en la escuela, la pérdida de objetos cotidianos genera frustración y desconexión. Por eso nació YourLostAndFound: para traer orden, conexión y tranquilidad—una etiqueta a la vez."
  },
  pt: {
    title: "Um problema diário. Uma solução humana.",
    text: "Em casa ou na escola, a perda de itens do dia a dia causa frustração e desconexão. Foi por isso que o YourLostAndFound foi criado: para trazer ordem, conexão e tranquilidade—uma etiqueta de cada vez."
  }
};

const images = [
  {
    src: '/assets/images/About/parent.webp',
    alt: {
      en: 'Child at home gesturing confusion about lost water bottle',
      es: 'Niño en casa expresando confusión sobre su termo perdido',
      pt: 'Criança em casa demonstrando confusão sobre garrafa perdida'
    }
  },
  {
    src: '/assets/images/About/school.webp',
    alt: {
      en: 'Lost and found area at a school with bottles and backpacks',
      es: 'Área de objetos perdidos en una escuela con termos y mochilas',
      pt: 'Área de achados e perdidos em uma escola com garrafas e mochilas'
    }
  }
];

export default function AboutIntroCards({ language = 'en' }) {
  return (
    <>
      <section className="bg-[#f0fdfc] py-16 text-center px-6">
        <div className="max-w-[1536px] mx-auto">
          <h3 className="text-3xl md:text-4xl font-bold text-[#48887B] mb-4">
            {introBlock[language].title}
          </h3>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            {introBlock[language].text}
          </p>
        </div>
      </section>

      <section className="max-w-[1536px] mx-auto px-4 py-12 grid gap-10 md:grid-cols-2">
        {images.map((img, index) => (
          <div key={index} className="bg-white rounded-xl shadow-lg p-6 flex flex-col items-center text-center">
            <div className="w-full aspect-[4/3] overflow-hidden rounded-md mb-4">
              <img
                src={img.src}
                alt={img.alt[language]}
                className="w-full h-full object-cover object-center"
              />
            </div>
            <p className="text-lg font-semibold text-gray-700">{questions[language][index]}</p>
          </div>
        ))}
      </section>
    </>
  );
}
